import React from "react";
import { Dialog, Transition } from "@headlessui/react";
import { Fragment, useEffect, useState } from "react";
import DocImg from "../images/doc.svg";
import RemoveImg from "../images/delete.svg";
import { baseURL } from "../constants/Api";
import axios from "axios";
import ButtonLoader from "./loaders/ButtonLoader";
import { CheckOutSubmitButtonClick } from "../utils/Analytics";
function CheckoutForm(props) {
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const reservationId = localStorage.getItem("reservationId");
  const [loading, setLoading] = useState(false);

  function closeModal() {
    props.hide();
  }

  const checkOutReq = async () => {
    var data = {
      reservationId,
    };
    CheckOutSubmitButtonClick();
    setLoading(true);
    try {
      await axios({
        method: "post",
        url: `${baseURL}/api/preCheckoutV21`,
        data: data,
        headers: { "Content-Type": "application/json" },
      }).then(function (response) {
        setLoading(false);
        if (response) {
          setSuccess(true);
          localStorage.setItem('checkout', true); 
          props.setCheckorNot(true);
            closeModal();
            props.setCheckOutConfirmation(true);
       
         
        }
      });
    } catch (error) {
      setLoading(false);
      setError("axios");
    }
  };

  return (
    <div>
      <>
        <Transition appear show={true} as={Fragment}>
          <Dialog as="div" className="relative z-[999999]" onClose={closeModal}>
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="fixed inset-0 bg-black/25" />
            </Transition.Child>

            <div className="fixed inset-0 overflow-y-auto">
              <div className="flex min-h-full items-center justify-center p-4 text-center">
                <Transition.Child
                  as={Fragment}
                  enter="ease-out duration-300"
                  enterFrom="opacity-0 scale-95"
                  enterTo="opacity-100 scale-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100 scale-100"
                  leaveTo="opacity-0 scale-95"
                >
                  <Dialog.Panel className="w-full alert-modal max-w-md transform overflow-hidden rounded-2xl bg-[#171538] p-4 pt-2 text-left align-middle shadow-xl transition-all">
                    <Dialog.Title
                      as="h3"
                      className="text-lg font-medium leading-6 text-gray-900"
                    ></Dialog.Title>
                    <div className="doc-modal flex-col items-center justify-center mt-2">
                      <div className="flex justify-center items-center"></div>
                      <div className="head">Do you want to check-out?</div>
                      <div className="text-gray-500 font-normal text-[14px] mt-2 mb-3">By checking out, services will no longer be available for request.</div>
                      <button
                        onClick={checkOutReq}
                        className="mt-3 cancel text-center relative"
                      >
                        Check out
                        {loading && <ButtonLoader />}
                      </button>
                      <button
                        onClick={closeModal}
                        className="mt-3 upload-btn w-full"
                      >
                        Cancel
                      </button>
                      {error == "axios" && (
                        <div className="w-full flex justify-center">
                          <div className="error-doc text-center mt-3">
                            something went wrong
                          </div>
                        </div>
                      )}
                      {/* {success && (
                        <div className="w-full flex justify-center">
                          <div className="success-doc text-center mt-3">
                            Successfully Requested!
                          </div>
                        </div>
                      )} */}
                    </div>
                    <div className="flex w-full justify-center mt-3 relative"></div>

                    <div className="absolute top-2 right-2 ">
                      <button
                        type="button"
                        className="outline-none rounded-full hover:bg-[#342f4f]"
                        onClick={closeModal}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          strokeWidth="1"
                          stroke="white"
                          className="w-6 h-6 "
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M6 18L18 6M6 6l12 12"
                          />
                        </svg>
                      </button>
                    </div>
                  </Dialog.Panel>
                </Transition.Child>
              </div>
            </div>
          </Dialog>
        </Transition>
      </>
    </div>
  );
}

export default CheckoutForm;
